import { Group } from "@mantine/core"
import { SuperAdminVenueAreaTabs } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaTabs"
import { EditSuperAdminVenueAreaAction } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { SuperAdminVenueAreaView } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaView"

export function SuperAdminVenueArea() {

    const { currentItem } = useAppState(state=>state.areas)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminVenueAreaAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminVenueAreaTabs/>
            <SuperAdminVenueAreaView/>
        </PageLayout>
    )

}